import React from "react";
import "./css/LoginSinup.css";

const LoginSinup = () => {
  return (
    <div className="loginSinup">
      <div className="loginSinup-container">
        <h1>Sing Up</h1>
        <div className="loginSignup-fields">
          <input type="text" placeholder="Enter Your Name" />
          <input type="email" placeholder="Enter Your Email Address" />
          <input type="pssword" placeholder="Enter Your Password" />
        </div>
        <button>Continue</button>
        <p className="loginSignup">
          Alredy have an account? <span>Login here</span>
        </p>
        <div className="loginsignup-agree">
          <input type="checkbox" name="" id="" />
          <p>By Continuing, i agree to the terms of use & privacy poliysic</p>
        </div>
      </div>
    </div>
  );
};

export default LoginSinup;
